import { useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useStore = () => {
  const { api } = useContext(GlobalContext);

  const postRequest = useCallback(
    async (endpoint, payload = {}) => {
      const response = await api.post(endpoint, payload);
      return response?.data;
    },
    [api],
  );

  // GET ALL STORES
  const getStores = useCallback(async () => {
    try {
      const data = await postRequest("/Order/v2.0/getStoresInstamart", {});

      return data?.response || [];
    } catch (error) {
      console.error("getStores error:", error);
      return [];
    }
  }, [postRequest]);

  // GET STORE ITEMS
  const getStoreItems = useCallback(
    async (fkUserId) => {
      if (!fkUserId) return [];

      try {
        const response = await api.post(
          `/Order/v2.0/getSyncItemsInstamartAdmin?fk_userid=${fkUserId}`,
          {},
        );

        return response?.data?.response || [];
      } catch (error) {
        console.error("getStoreItems error:", error);
        return [];
      }
    },
    [api],
  );

  // UPDATE ITEM STATUS
  const updateItemStatus = useCallback(
    async (payload) => {
      try {
        console.log("UpdateMenuItemAdmin payload:", payload);

        const data = await postRequest("/Order/UpdateMenuItemAdmin", payload);

        console.log("UpdateMenuItemAdmin response:", data);

        return data;
      } catch (error) {
        console.error("updateItemStatus error:", error);
        throw error;
      }
    },
    [postRequest],
  );

  return {
    getStores,
    getStoreItems,
    updateItemStatus,
  };
};

export default useStore;
